module.exports = __webpack_public_path__ + "static/media/manzo_10_full.797b2329.jpg";